import { useEffect, useState } from "react";
import Common from "../../helper/common";
import {
  TermsnConditionTypeEnum,
} from "../../constants/appConstant";
import { Button } from "../../components/ui/button";
import { Icon } from "@iconify/react";
import { AppSearchSelect } from "../../components/appComponents";
import AdvanceTable from "../../components/advanceTable";
import AddTermsnCondition from "./addTermsnConditions";

const TermsnConditions = () => {

    let [data, setData] = useState({});
    let [search, setSearch] = useState(null);
    const [open, setOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        getTermsAndConditions();
    }, []);

    const getTermsAndConditions = async (type = null) => {
        try {
            const response = await Common.ApiService.getInstance().request(
                `GetTermsnCondition${type ? `?type=${type}` : ""}`,
                "GET"
            );
            if (response?.data?.length) {
                let _data = response?.data.map((item) => ({
                    id: item.id,
                    type: Common.Utility.getKeyByValue(TermsnConditionTypeEnum, item.type),
                    condition: item.condition ?? "-",
                    // createdOn: Common.Utility.ConvertTime(item.createdOn),
                    // updatedOn: Common.Utility.ConvertTime(item.updatedOn),
                    // createdBy: item.createdBy ?? "-",
                    // updatedBy: item.updatedBy ?? "-",
                    // clubId: item.clubId,
                }));
                setData({ data: _data });
            } else {
                setData({ data: [] });
                //alert("No terms found");
            }
        } catch (error) {
            console.error("Error fetching terms and conditions:", error);
        }
    };

    const columns = [
        { title: "ID", type: "number", isVisible: false, key: "id" },
        { title: "Type", type: "text", isVisible: true, key: "type" },
        {
            title: "Condition",
            type: "text",
            isVisible: true,
            key: "condition",
            render: (item) => (
                <div style={{ whiteSpace: "pre-wrap" }}>{item.condition}</div>
            ),
        },
        // { title: "Club ID", type: "number", isVisible: true, key: "clubId" },
        // { title: "Created On", type: "date", isVisible: true, key: "createdOn" },
        // { title: "Created By", type: "text", isVisible: true, key: "createdBy" },
        // { title: "Updated On", type: "date", isVisible: true, key: "updatedOn" },
        // { title: "Updated By", type: "text", isVisible: true, key: "updatedBy" },
    ];

    const _handleDelete = async (id) => {
        const isConfirmed = await Common.SweetAlert.confirmation(
            "Are you sure want to delete this Terms and Conditions??",
            "Delete Terms and Conditions"
        );

        if (isConfirmed) {
            let resp = await Common.ApiService.getInstance().request(
                `DeleteTermsnConditions?id=${id}`,
                {},
                "Delete"
            );

            Common.SweetAlert.alert(resp.message, "success");

            setTimeout(() => {
                getTermsAndConditions();
            }, 500);
        }
    };

    const handleEdit = (item) => {
        setEditId(item.id);
        setSelectedItem(item); 
        setOpen(true);
    };

    const handleClose = () => {
        setEditId(null);
        getTermsAndConditions(search); 
    };

    const actions = [
        {
            type: "edit",
            onClick: handleEdit,
        },
        {
            type: "delete",
            onClick: (val) => _handleDelete(val.id),
        },
    ];


    const TermsnConditionTypeOptions = Object.values(TermsnConditionTypeEnum).map((id) => ({
        id,
        name: Common.Utility.getKeyByValue(TermsnConditionTypeEnum, id),
    }));

    const resetFilters = () => {
        // setfromDate(null);
        // settillDate(null);
        setSearch(null);
        getTermsAndConditions(null);
    };

    return (
        <>
            <div className="md:grid md:grid-cols-6 gap-3 h-150 w-150 ">
                <AppSearchSelect
                    value={search}
                    onChange={(val) => {
                        setSearch(val);
                        getTermsAndConditions(val);
                    }}
                    placeholder={"All"}
                    label={"Type"}
                    data={TermsnConditionTypeOptions}
                    className={"mb-3 col-span-1"}
                />

                <Button className="lg:mt-6 h-8 mb-5" onClick={resetFilters}>
                    Reset Filter
                </Button>
            </div>
            <AdvanceTable
                title={"Terms and Conditions"}
                columns={columns.filter((item) => item.isVisible)}
                data={data}
                getData={getTermsAndConditions}
                addButton={() => (
                    <Button onClick={() => {
                        setEditId(null);
                        setOpen(true);
                        setSelectedItem(null); 
                    }}>
                        + Add
                    </Button>
                )}
                showAddButton
                //showPagination
                actionButtons={actions}
                //updateTrigger={_addUpdateTrigger}
                searchInputClassName="custom-search-mobile"
                //Search={SearchTypeEnum.Server_Search}
            />

            {/* Initialize the dialog */}
            <AddTermsnCondition
                id={editId}
                open={open}
                setOpen={setOpen}
                onClose={handleClose}
                selectedItem={selectedItem}
            />
        </>
    );

};
export default TermsnConditions;
